export default __webpack_public_path__ + "static/media/bg14.70a36c91.jpg";